import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { useState } from 'react';
import { InputContainer, Input } from './styled';

interface PollingInputChoiceProps {
  iconRemove?: () => any;
  onChange?: (val: any) => any;
  [key: string]: any;
}

function PollingInputChoice({ iconRemove, onChange, ...otherProps }: PollingInputChoiceProps) {
  const [maxCharLabel, setMaxCharLabel] = useState(25);
  const maxChar = 25;
  const subtract = (varible, constant) => constant - varible;

  const suffix = (
    <Text size="14px" color={color.midgray}>
      {maxCharLabel}
    </Text>
  );

  return (
    <InputContainer>
      <Input
        {...otherProps}
        onChange={(e) => {
          onChange(e);
          setMaxCharLabel(subtract(e.currentTarget.value.length, maxChar));
        }}
        maxLength={maxChar}
        height="40px"
        // @ts-expect-error
        mb="14px"
        width="100%"
        suffix={suffix}
      />
      {iconRemove && iconRemove()}
    </InputContainer>
  );
}

export default PollingInputChoice;
